import { Paper } from "@mui/material";

const CaltexCard = (props) => {
    return (
        <Paper sx={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;" }}>
            {props.children}
        </Paper>
    );
};

export default CaltexCard;
